import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import { getViewInstance } from "../actions/viewinstance";

import Header from "./layouts/Header";
import { Grid, TextField, Paper, Typography, MenuItem, InputLabel, FormControl, Select, Autocomplete, Button, Skeleton, Box } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { fetchErrorMessages, selectErrorMessagesByKeyName } from "../reducers/reference_errormessages";
import { createProfileAddress, updateProfileAddress, updateProfileDemographics } from "../reducers/profile";
import Footer from "./layouts/Footer";
import { viewinstanceClear } from "../reducers/reuseable_vi";

//import { getPWRequest } from "../actions/viewinstance";

const Profile = (props) => {
  const navigate = useNavigate()
  const [callVI, setCallVI] = useState(false)
  const { viewInstance, settings } = useSelector(state => state.viewinstance)
  const { user: currentUser } = useSelector((state) => state.auth);
  
  const errormessageStatus = useSelector(state => state.errormessages.status)

  const FirstNameError = useSelector(state=>selectErrorMessagesByKeyName(state,'VAL FIRST NAME'))
  const LastNameError = useSelector(state=>selectErrorMessagesByKeyName(state,'VAL LAST NAME'))
  const EmailError = useSelector(state=>selectErrorMessagesByKeyName(state,'VAL EMAIL PROFILE'))
  const DobError = useSelector(state=>selectErrorMessagesByKeyName(state,'VAL DATEOFBIRTH'))
  const [paramData, setParamData] = useState({
    AuthToken: '',
    ParticipantGuid: '',
    GroupGuid: '',
    ParticipantGroupGuid: '~~',
    LanguageID: '',
    LastName: '',
    MiddleName: '~_~',
    FirstName: '',
    BioDOB: '',
    BioGender: '',
    BioRace: '',
    BioRace2: '~_~',
    BioRace3: '~_~',
    Email: '',
    SpokenLanguageID: '',
    EducationLevelGuid: '',
    ParticipantAddressGuid: '',
    ParticipantAddressTypeGuid: '',
    ZipCode: '',
    CountryCode: '',
    validLastName: true,
    validFirstName: true,
    validDoB: true,
    validGender:true,
    validRace:true,
    validEmail: true,
    validSpokenLanguage:true,
    validEducation:true,
    validZipCode: true,
    validCountry:true,
  })

  const dispatch = useDispatch()

  useEffect(() => {
  })

  useEffect(() => {
    if ( !callVI) {
      setCallVI(true)
      dispatch(getViewInstance('5F6382C5-1CEF-461B-9539-7B428E5EA882', currentUser.AuthToken))
    }
  }, [window.location.pathname])

  useEffect(() => {
    if (errormessageStatus === 'idle') {
      dispatch(fetchErrorMessages({ groupGuid: localStorage.getItem('group'), languageID: -1 }))
    }

  }, [errormessageStatus, dispatch])

  useEffect(() => {
    if (settings && viewInstance && viewInstance.ProfileVI) {
      let educationGuid = viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationSQL ? 
                            viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationSQL[0].EducationTypeGuid 
                            : ''

      let race  = viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceSQL ? 
                    viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceSQL[0] 
                    : {RaceTypeId: "",
                      RaceTypeName: ""}
      
      let language = viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakDropdownList.find(option => option.LanguageTypeId === viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakTextValue) 
                      || {LanguageTypeId: "",
                       LanguageTypeName: "",
                       StandardContent: ""}
      let country = viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressCountryFrame.CountryDropdownList.find(country => country.CountryId === viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].CountryName)
                      || {
                        CountryName: "",
                        StandardContent: "",
                        CountryId: ""
                      }

      let zipcode = viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].PostalCode === "UNSPECIFIED" ? "" : viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].PostalCode
      
      setParamData({
        ...paramData,
        AuthToken: currentUser.AuthToken,
        ParticipantGuid: settings.SessionVariableValues['PERSON GUID'],
        GroupGuid: settings.SessionVariableValues['ORGANIZATION GUID'],
        LanguageID: settings.SessionVariableValues['LANGUAGE ID'],
        LastName: viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameTextValue,
        FirstName: viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameTextValue,
        BioDOB: viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthTextValue,
        BioGender: viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderTextValue,
        BioRace: race,
        Email: viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailTextValue,
        SpokenLanguageID: language,
        EducationLevelGuid: educationGuid,
        ZipCode: zipcode,
        CountryCode: country,
        ParticipantAddressGuid: viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].PersonAddressGuid,
        ParticipantAddressTypeGuid: viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].AddressTypeGuid,
        validLastName: validateLastName( viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameTextValue),
        validFirstName: validateFirstName( viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameTextValue),
        validDoB: validateDoB( viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthTextValue),
        validGender:validateGender( viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderTextValue),
        validRace:validateRace( race),
        validEmail: validateEmail( viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailTextValue),
        validSpokenLanguage:validateSpokenLanguage( language),
        validEducation:validateEducation( educationGuid),
        validZipCode: validateZipCode( zipcode),
        validCountry:validateCountry( country),
      })
    }

  }, [viewInstance])

  const saveProfile = () => {
    let saveData = paramData

    saveData = {
      ...saveData, LastName: sanitizeNull(paramData.LastName),
      FirstName: sanitizeNull(paramData.FirstName),
      BioDOB: sanitizeNull(paramData.BioDOB),
      BioGender: sanitizeNull(paramData.BioGender),
      BioRace: sanitizeNull(paramData.BioRace.RaceTypeId),
      SpokenLanguageID: sanitizeNull(paramData.SpokenLanguageID.LanguageTypeId),
      EducationLevelGuid: sanitizeNull(paramData.EducationLevelGuid),
      CountryCode: sanitizeNull(paramData.CountryCode.CountryId),
      ZipCode: sanitizeNull(paramData.ZipCode)
    }


    dispatch(updateProfileDemographics({"ParamData": saveData}));

    if(saveData.ParticipantAddressGuid.length){
      //update
      let addressUpdateString = "" + saveData.AuthToken + '/' + 
      saveData.ParticipantAddressGuid + "/" + 
      saveData.ParticipantAddressTypeGuid + "/" + 
      "~_~/~_~/~_~/~_~/~_~/~_~/" + 
      saveData.ZipCode + "/" + 
      saveData.CountryCode + "/"

      dispatch(updateProfileAddress(addressUpdateString))
    } else {
      //create, but only if there's data there to create
      if(paramData.ZipCode || paramData.CountryCode.CountryId){
        let addressCreateString = "" + saveData.AuthToken + '/' + 
        saveData.ParticipantGuid + "/" + 
        "90899741-5728-4F9C-A489-691131304962/" + 
        "~_~/~_~/~_~/~_~/~_~/~_~/" + 
        saveData.ZipCode + "/" + 
        saveData.CountryCode + "/"
        
        dispatch(createProfileAddress(addressCreateString))
      }
    }
    setCallVI(false)
    dispatch(viewinstanceClear("HomePage"))
    navigate('/home')
    return
  }

  const validateFirstName = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE NAME FIRST"]==="0"){
      paramData.validFirstName = true;
    }
    else if (!(/^[\p{L} ,.'-]+$/u).test(name)){
      paramData.validFirstName = false;
    }
    else{
      paramData.validFirstName = true;
    }
    return paramData.validFirstName;
  }
  const validateLastName = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE NAME LAST"]==="0"){
      paramData.validLastName = true;
    }  
    else if (!(/^[\p{L} ,.'-]+$/u).test(name)){
      paramData.validLastName = false;
    }
    else{
      paramData.validLastName = true;
    }
    return paramData.validLastName;
  }
  const validateEmail = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE EMAIL"]==="0"){
      paramData.validEmail = true;
    }
    else if (!(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/u).test(name)){
      paramData.validEmail = false;
    }
    else{
      paramData.validEmail = true;
    }
    return paramData.validEmail;
  }
  const validateDoB = (name) => {
    let currentTime = new Date().getTime();
    let birthDateTime= new Date(name).getTime();
    let difference = (currentTime - birthDateTime);
    var ageInYears=difference/(1000*60*60*24*365);

    let InvalidTooYoung = false;
    let InvalidTooOld = false;

    if (ageInYears < settings.OrganizationSettingValues["AGE MIN"]){
      InvalidTooYoung = true;
    }
    if (ageInYears > settings.OrganizationSettingValues["AGE MAX"]){
      InvalidTooOld   = true;
    }

    if(isNaN(ageInYears) &&  settings.OrganizationSettingValues["REQUIRE DOB"]==="0"){
      paramData.validDoB = true;
    }
    else if (InvalidTooOld || InvalidTooYoung || isNaN(ageInYears)){
      paramData.validDoB = false;
    }
    else{
      paramData.validDoB = true;
    }
    return paramData.validDoB;
  }

  const validateRace = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE RACE"]==="0"){
      paramData.validRace = true;
    }  
    else if (!name){
      paramData.validRace = false;
    }
    else{
      paramData.validRace = true;
    }
    return paramData.validRace;
  }

  const validateGender = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE GENDER"]==="0"){
      paramData.validGender = true;
    }  
    else if (!name){
      paramData.validGender = false;
    }
    else{
      paramData.validGender = true;
    }
    return paramData.validGender;
  }

  const validateEducation = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE EDUCATION"]==="0"){
      paramData.validEducation = true;
    }  
    else if (!name){
      paramData.validEducation = false;
    }
    else{
      paramData.validEducation = true;
    }
    return paramData.validEducation;
  }

  const validateSpokenLanguage = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE LANGSPEAK"]==="0"){
      paramData.validSpokenLanguage = true;
    }  
    else if (!name){
      paramData.validSpokenLanguage = false;
    }
    else{
      paramData.validSpokenLanguage = true;
    }
    return paramData.validSpokenLanguage;
  }

  const validateCountry = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE COUNTRY"]==="0"){
      paramData.validCountry = true;
    }  
    else if (!name){
      paramData.validCountry = false;
    }
    else{
      paramData.validCountry = true;
    }
    return paramData.validCountry;
  }

  const validateZipCode = (name) => {
    if(!name && settings.OrganizationSettingValues["REQUIRE ZIP"]==="0"){
      paramData.validZipCode = true;
    }  
    else if (!name){
      paramData.validZipCode = false;
    }
    else{
      paramData.validZipCode = true;
    }
    return paramData.validZipCode;
  }
  // used to readjust default validation values.

  
  

  const sanitizeNull = (val) => {
    if (!val || val === -1) {
      return "~_~"
    } return val
  }

  return (
    <div>
      <Header type="PRPS" />
      {viewInstance && viewInstance.ProfileVI ?
        (


          <Paper elevation={16} style={{ marginTop: '150px', padding: '40px' }}>
            <div>
              <Typography variant="h5">{viewInstance.ProfileVI.MenuProfile.ProfileGreeting}</Typography>
              <Typography variant="subtitle1">{viewInstance.ProfileVI.MenuProfile.ProfileSubgreeting}</Typography>
            </div>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item md={6} xs={12}>
                <div>
                  <TextField id="first-name" sx={{ margin: '5px' }} fullWidth
                    label={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameText}
                    value={paramData.FirstName}
                    error={!paramData.validFirstName}
                    helperText={paramData.validFirstName ? '' : FirstNameError && FirstNameError.length>0 && FirstNameError[0].MessageTypeContent}
                    required={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameRequiredFlag === "1"}
                    disabled={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameReadOnlyFlag === "1"}
                    onChange={(e) => { setParamData({ ...paramData, FirstName: e.target.value }) }}
                    onBlur={(e) => { setParamData({ ...paramData, validFirstName : validateFirstName(e.target.value)})}}/>
                </div>
              </Grid>
              <Grid item md={6} xs={12} sx={{display: viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameVisibleFlag === "0" ? "none" : ""}}>
                <div>
                  <TextField id="last-name" sx={{ margin: '5px' }} fullWidth
                    label={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameText}
                    value={paramData.LastName}
                    error={!paramData.validLastName}
                    helperText={paramData.validLastName ? '' : LastNameError && LastNameError.length>0 && LastNameError[0].MessageTypeContent}
                    required={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameRequiredFlag === "1"}
                    disabled={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameReadOnlyFlag === "1"}
                    onChange={(e) => { setParamData({ ...paramData, LastName: e.target.value }) }}
                    onBlur={(e) => { setParamData({ ...paramData, validLastName : validateLastName(e.target.value)})}}/>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div>
                  <TextField id="email" sx={{ margin: '5px' }} fullWidth
                    inputProps={{pattern: "^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$" }}
                    label={viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailText}
                    value={paramData.Email}
                    error={!paramData.validEmail}
                    helperText={paramData.validEmail ? '' : EmailError && EmailError.length>0 && EmailError[0].MessageTypeContent}
                    required={viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailRequiredFlag === "1"}
                    disabled={viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailReadOnlyFlags === "1"}
                    onChange={(e) => { setParamData({ ...paramData, Email: e.target.value }) }}
                    onBlur={(e) => { setParamData({ ...paramData, validEmail : validateEmail(e.target.value)})}}/>

                </div>
              </Grid>
              <Grid item md={6} xs={12} >
                <div style={{ margin: '5px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en'>
                    <DatePicker
                      label={viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthLabel}
                      value={paramData.BioDOB}
                      disabled={viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthReadOnlyFlag === "1"}
                      required={viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthRequiredFlag === "1"}
                      format="MM-DD-YYYY"
                      onChange={(newValue) => {
                        setParamData({ ...paramData, BioDOB: dayjs(newValue).format('MM-DD-YYYY'), validDoB : validateDoB(dayjs(newValue).format('MM-DD-YYYY')) });
                      }}
                      onBlur={(newValue) => { setParamData({ ...paramData, BioDOB: dayjs(newValue).format('MM-DD-YYYY'), validDoB : validateDoB(dayjs(newValue).format('MM-DD-YYYY'))})}}
                      renderInput={(params) => <TextField
                      {...params} error={!paramData.validDoB} helperText={paramData.validDoB ? '': DobError && DobError.length>0 && DobError[0].MessageTypeContent
                    //  'Date of birth is invalid or age is outside of accepted range of '+settings.OrganizationSettingValues["AGE MIN"]+'-'+settings.OrganizationSettingValues["AGE MAX"]+'.'
                    }/>}
                      disableFuture
                    />
                  </LocalizationProvider>
                </div>

              </Grid>
              <Grid item md={6} xs={12}>
                <div style={{ margin: '5px' }}>
                  <FormControl fullWidth required={viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationRequiredFlag === "1"}>
                    <InputLabel>{viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationLabel}</InputLabel>
                    <Select
                      value={paramData.EducationLevelGuid}
                      label={viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationLabel}
                      onChange={(e) => { setParamData({ ...paramData, EducationLevelGuid: e.target.value, validEducation:validateEducation(e.target.value) }) }}
                      
                    >
                      {viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationList.map(education =>
                        <MenuItem style={{ whiteSpace: 'normal' }} value={education.EducationTypeGuid}>{education.EducationTypeName}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div style={{ margin: '5px' }}>
                  <FormControl fullWidth  required={viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderRequiredFlag === "1"}>
                    <InputLabel>{viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderLabel}</InputLabel>
                    <Select
                      value={paramData.BioGender}
                      label={viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderLabel}
                     

                      onChange={(e) => { setParamData({ ...paramData, BioGender: e.target.value, validGender:validateGender(e.target.value) }) }}
                    >
                      {viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.ProfileGenderLabels.map(gender =>
                        <MenuItem style={{ whiteSpace: 'normal' }} value={gender.GenderTypeId}>{gender.GenderTypeName}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>

              </Grid>
              <Grid item md={6} xs={12}>
                <div style={{ margin: '5px' }}>
                  <Autocomplete
                    options={viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakDropdownList}
                    getOptionLabel={(option) => option.StandardContent}
                    autoHighlight
                    value={paramData.SpokenLanguageID}
                    renderInput={(params) => <TextField {...params} label={viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakLabel} />}
                    required={viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakRequiredFlag === "1"}
                    
                    onChange={(e, newValue) => { setParamData({ ...paramData, SpokenLanguageID: newValue, validSpokenLanguage: validateSpokenLanguage(newValue) }) }}
                  />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div style={{ margin: '5px' }}>
                  <Autocomplete
                    options={viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.ProfileRaceLabels}
                    getOptionLabel={(option) => option.RaceTypeName}
                    required={viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceRequiredFlag === "1"}
                    autoHighlight
                    value={paramData.BioRace}
                    renderInput={(params) => <TextField {...params} label={viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceLabel} />}
                    onChange={(e, newValue) => { setParamData({ ...paramData, BioRace: newValue, validRace:validateRace(newValue) }) }}
                  />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div style={{ margin: '5px' }}>
                  <Autocomplete
                    options={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressCountryFrame.CountryDropdownList}
                    getOptionLabel={(option) => option.StandardContent}
                    autoHighlight
                    value={paramData.CountryCode}
                    renderInput={(params) => <TextField {...params} label={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressCountryFrame.CountryText} />}
                    onChange={(e, newValue) => { setParamData({ ...paramData, CountryCode: newValue, validCountry:validateCountry(newValue) }) }}
                  />

                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div style={{ margin: '5px' }}>
                  <TextField fullWidth
                    label={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressZipcodeFrame.ZipcodeText}
                    required={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressZipcodeFrame.ZipcodeRequiredFlag === "1"}
                    value={paramData.ZipCode}
                    onChange={(e) => { setParamData({ ...paramData, ZipCode: e.target.value, validZipCode:validateZipCode(e.target.value) }) }} 
                  />
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth variant="contained" 
              disabled={!(
                paramData.validCountry &&
                paramData.validDoB &&
                paramData.validFirstName &&
                paramData.validLastName &&
                paramData.validRace &&
                paramData.validEducation &&
                paramData.validEmail &&
                paramData.validZipCode &&
                paramData.validGender &&
                paramData.validSpokenLanguage 

              )} 
              onClick={() => saveProfile()}>{viewInstance.ProfileVI.MenuProfile.SaveButton}</Button>

            </Grid >

          </Paper>
        ) : (

          <Box p={2} mt={2} alignItems="center" justifyContent="center" style={{ marginTop: '150px', padding: '40px' }}>
            <Paper>


              <Skeleton width="100%"><Typography>.</Typography></Skeleton>
              <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>
                  <Skeleton width="100%" height={100}><Typography>.</Typography></Skeleton>

                </Grid>
              </Grid>

            </Paper>
          </Box>



        )

      }
      <Footer/>
    </div>
  );


};

export default Profile;